define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("manager-templates/special-occasion/specialOccasionEditView.tmpl");
    var InputField = require("ui/input-field/InputField");
    var InlineTextarea = require("ui/inline-textarea/InlineTextarea");
    var Button = require("ui/button/Button");
    var Dropdown = require("ui/dropdown/Dropdown");
    var Bubble = require("ui/bubble/Bubble");
    var Dialog = require("ui/dialog/Dialog");
    var SpecialOccasionEventTimeFrameView = require("manager-views/special-occasion/SpecialOccasionEventTimeFrameView");
    var Config = require("manager-assets/config/config.json");

    var OrganizeCollectionDecorator = require("decorators/organizeCollectionDecorator/OrganizeCollectionDecorator");
    var SpecialOccasionEventsTableView = require("manager-views/special-occasion/SpecialOccasionEventsTableView");
    var SpecialOccasionEventsComparators = require("manager-comparators/SpecialOccasionEventsComparators");
    var SpecialOccasionEventsTableModel = require("manager-models/special-occasion/SpecialOccasionEventsTableModel");
    var SpecialOccasionModel = require("models/entities/SpecialOccasionModel");

    var SpecialOccasionEditView = {};

    function moduleDefinition(LEManager, LE, Backbone, Marionette, $, _) {
        SpecialOccasionEditView = Marionette.ItemView.extend({
            template: template,
            ui: {
                editSpecialOccasionWrapper: ".edit-special-occasion-wrapper",
                nameInputContainer: ".special-occasion-name-wrapper .input-container",
                descriptionContainer: ".special-occasion-description-container",
                timeZoneContainer: ".special-occasion-time-zone-wrapper .dropdown-container",
                specialOccasionTableContainer: ".special-occasion-table-wrapper .special-occasion-table-container",
                timeFrameDialogContainer: ".time-frame-dialog-container",
                addSpecialOccasionEventButton: ".add-special-occasion-event-button",
                clearAllButton: ".clear-all-button",
                totalEvents: ".total-events",
                cancelButton: ".button-cancel",
                saveButton: ".button-save"
            },
            uiComponents: {
                specialOccasionName: {
                    type: InputField,
                    options:{
                        permutation:InputField.Permutation.B,
                        el: "view.ui.nameInputContainer",
                        maxLength: Config.validators.specialOccasions.maxNameLength,
                        value: "view._getSpecialOccasionName"
                    },
                    events:{
                        change:"_onSpecialOccasionNameChange"
                    }
                },
                specialOccasionDescription: {
                    type: InlineTextarea,
                    options: {
                        permutation: InlineTextarea.PERMUTATION.D,
                        container: "view.ui.descriptionContainer",
                        value: "view._getSpecialOccasionDescription",
                        maxChars: Config.validators.specialOccasions.maxDescriptionLength
                    },
                    events: {
                        change: "_onSpecialOccasionDescriptionChange"
                    }
                },
                specialOccasionTimeZone:{
                    type: Dropdown,
                    options:{
                        container: "view.ui.timeZoneContainer",
                        items: "view._getTimezoneOptions",
                        selectedOption: "view._getSelectedTimeZone",
                        testCollision: true,
                        collisionWithinSelector: ".le .manager-region .edit-special-occasion.view-container"
                    },
                    events:{
                        "change":"_onTimeZoneDropdownChange"
                    }
                },
                specialOccasionsTable: {
                    type: SpecialOccasionEventsTableView,
                    options: {
                        el: "view.ui.specialOccasionTableContainer",
                        collection: "view.specialOccasionEventsCollection",
                        channel: "view.channel",
                        comparators: SpecialOccasionEventsComparators,
                        model: "view._getSpecialOccasionEventsModel"
                    }
                },
                addSpecialOccasionEventButton: {
                    type: Button,
                    options: {
                        el: "view.ui.addSpecialOccasionEventButton"
                    },
                    events: {
                        "click": "_addSpecialOccasionEvent"
                    }
                },
                clearAllButton: {
                    type: Button,
                    options: {
                        el: "view.ui.clearAllButton",
                        permutation: Button.PERMUTATION.BLUELINK,
                        initState: "view._getClearAllButtonState"
                    },
                    events: {
                        "click": "_clearAllEvents"
                    }
                },
                cancelButton: {
                    type: Button,
                    options: {
                        el: "view.ui.cancelButton",
                        permutation: Button.PERMUTATION.LINK
                    },
                    events: {
                        "click": "_onCancel"
                    }
                },
                saveButton: {
                    type: Button,
                    options: {
                        el: "view.ui.saveButton",
                        permutation: Button.PERMUTATION.BTN_PRIMARY,
                        tooltipAlign: Button.TOOLTIP_ALIGN.RIGHT,
                        initState: Button.STATES.ENABLED
                    },
                    events: {
                        "click": "_onSave"
                    }
                }
            },
            events: {
                "mouseenter @ui.addSpecialOccasionEventButton": "_showAddEventBubble",
                "mouseleave @ui.addSpecialOccasionEventButton": "_closeAddEventBubble",
            },

            initialize: function(options) {
                this._initialize(options);
            },

            onRender: function() {
                this._onRender();
            },

            onInvalid: function(model, errors) {
                this._onInvalid(model, errors);
            },

            _initialize: function(options) {
                this.channel = options.channel;
                this.timeFrameView = null;
                this.originalEventsCollection = this.model.getEventsCollection();
                this.specialOccasionEventsCollection = OrganizeCollectionDecorator.decorate(this.originalEventsCollection, {});
            },

            _onRender: function() {
                this._updateTotalNumberOfItems();
                this.uiComponents.specialOccasionsTable.triggerTimeFrameSort();
                this._bindEvents();
                this._updateSaveButtonState();
            },

            _bindEvents: function() {
                this.listenTo(this.model, "change", this._updateSaveButtonState);
                this.listenTo(this, "page:closeButtonClick", this._onCancel);
                this.listenTo(this.channel.vent, "SpecialOccasionEventsTable:click:timeFrame", this._onTimeFrameClick);
                this.listenTo(this.channel.vent, "SpecialOccasionEventsTable:change:id", this._onEventIdChanged);
                this.listenTo(this.channel.vent, "SpecialOccasionEventsTable:event:remove", this._onEventRemoved);
                this.listenTo(this.channel.vent, "save:error", this._onInvalid);
                this.listenTo(this.originalEventsCollection, "reset", this._onSpecialOccasionEventsReset);
                this.listenTo(this.originalEventsCollection, "add", this._onEventAdded);
            },

            _onInvalid: function(model, errors) {
                this._hideErrors();

                if (_.has(errors, SpecialOccasionModel.KEYS.NAME)){
                    this.uiComponents.specialOccasionName.setError(true, LE.translator.translate(errors[SpecialOccasionModel.KEYS.NAME]));
                }
                if (_.has(errors, SpecialOccasionModel.KEYS.DESCRIPTION)){
                    this.uiComponents.specialOccasionDescription.setError(true, LE.translator.translate(errors[SpecialOccasionModel.KEYS.DESCRIPTION]));
                }
            },

            _hideErrors: function() {
                this.uiComponents.specialOccasionName.setError(false);
                this.uiComponents.specialOccasionDescription.setError(false);
            },

            _onSpecialOccasionEventsReset: function() {
                this.specialOccasionEventsCollection.organize();
                this._toggleAddEventButtonState(true);
                this._updateTotalNumberOfItems();
                this._updateClearAllButtonState();
            },

            _updateTotalNumberOfItems: function() {
                var totalEvents = this.model.getEventsCollection().length;
                this.ui.totalEvents.text(totalEvents);
            },

            _onEventAdded: function() {
                this._toggleAddEventButtonState(false);
                this._updateTotalNumberOfItems();
                this._updateClearAllButtonState();
            },

            _getSpecialOccasionName: function() {
                return this.model.getName();
            },

            _onSpecialOccasionNameChange: function(componentId, eventName, value) {
                this.channel.trigger("SpecialOccasionEditView:change:name", value);
            },

            _getSpecialOccasionDescription: function() {
                return this.model.getDescription();
            },

            _onSpecialOccasionDescriptionChange: function(componentId, eventName, value) {
                this.channel.trigger("SpecialOccasionEditView:change:description", value);
            },

            _getTimezoneOptions: function() {
                var timeZoneList = LE.siteSettings.timeZoneSettings.getTimeZoneListTranslated();
                _.each(timeZoneList, function(item){
                    item.searchKey = item.value.substring(12,item.value.length).trim().toLowerCase();
                });
                return new Dropdown.Collection(timeZoneList);
            },

            _getSelectedTimeZone: function() {
                return this.model.getTimezone();
            },

            _onTimeZoneDropdownChange: function(componentId, eventName, value) {
                this.channel.trigger("SpecialOccasionEditView:change:timezone", value.selectedKey);
            },

            _getSpecialOccasionEventsModel: function() {
                return new SpecialOccasionEventsTableModel();
            },

            _addSpecialOccasionEvent: function() {
                this.channel.trigger("SpecialOccasionEditView:actions:events:new");
            },

            _clearAllEvents: function() {
                this.channel.trigger("SpecialOccasionEditView:actions:events:clearAll");
            },

            _getClearAllButtonState: function() {
                return this.specialOccasionEventsCollection.length > 0 ? Button.STATES.ENABLED : Button.STATES.DISABLED;
            },

            _updateClearAllButtonState: function() {
                this.uiComponents.clearAllButton.setState(this._getClearAllButtonState());
            },

            _onEventRemoved: function(eventModel) {
                if (eventModel.isNew()) {
                    this._toggleAddEventButtonState(true);
                }
                this._updateTotalNumberOfItems();
                this._updateClearAllButtonState();
            },

            _toggleAddEventButtonState: function(enabled) {
                this.uiComponents.addSpecialOccasionEventButton.setEnabled(enabled);
            },

            _onTimeFrameClick: function(itemModel, target) {
                this.eventModel = itemModel;
                if (this.timeFrameView !== null) {
                    this._closeTimeFrameDialog();
                }
                this._openTimeFrameDialog();
            },

            _onEventIdChanged: function() {
                this._toggleAddEventButtonState(true);
            },

            _openTimeFrameDialog: function(itemModel) {
                this.timeFrameView = new SpecialOccasionEventTimeFrameView({
                    eventModel: this.eventModel,
                    specialOccasionModel: this.model,
                    channel: this.channel
                });

                this._bindTimeFrameViewEvents();

                this.dialog = new Dialog({
                    innerView: this.timeFrameView,
                    moduleName: LEManager.moduleName,
                    context: LE.context,
                    permutation: Dialog.PERMUTATION.C
                });

                this.ui.timeFrameDialogContainer.append(this.dialog.render().$el);
            },

            _bindTimeFrameViewEvents: function() {
                this.listenTo(this.timeFrameView, "SpecialOccasionEventTimeFrameView:save", this._onTimeFrameSave);
                this.listenTo(this.timeFrameView, "SpecialOccasionEventTimeFrameView:close", this._closeTimeFrameDialog);
            },

            _closeTimeFrameDialog: function() {
                this.stopListening(this.timeFrameView);
                this.dialog.close();
                this.timeFrameView = null;
            },

            _onTimeFrameSave: function(timeFrame) {
                this.channel.trigger("SpecialOccasionEventsTable:change:timeFrame", this.eventModel, timeFrame);
                this._closeTimeFrameDialog();
            },

            _onSave: function() {
                this.channel.trigger("SpecialOccasionEditView:save");
            },

            _onCancel: function() {
                this.channel.trigger("SpecialOccasionEditView:cancel");
            },

            _updateSaveButtonState: function () {
                var isModelValid = this.model.validateMandatoryFilled();

                if (!isModelValid) {
                    this.uiComponents.saveButton.setEnabled(false);
                    this.uiComponents.saveButton.setTooltip(LE.translator.translate("LEManager.specialOccasionEditView.saveButton.tooltip.mandatoryFields"));
                }
                else {
                    this.uiComponents.saveButton.setEnabled(true);
                    this.uiComponents.saveButton.setTooltip("");
                }
            },

            _showAddEventBubble: function() {
                if (this.uiComponents.addSpecialOccasionEventButton.getState() === Button.STATES.DISABLED) {
                    this._closeAddEventBubble(null, true);
                    this.uiComponents.host$.createAndRender("addEventBubble", {
                        type: Bubble,
                        options: {
                            targetControl: this.ui.addSpecialOccasionEventButton,
                            position: Bubble.POSITION.BOTTOM,
                            showCloseButton: false,
                            isDelayed: true,
                            text: LE.translator.translate("LEManager.specialOccasionEditView.eventsTable.addLine.tooltip")
                        }
                    });
                }
            },

            _closeAddEventBubble: function(event, force) {
                if (this.uiComponents.addEventBubble) {
                    this.uiComponents.addEventBubble.close(force);
                }
            }
        });
    }

    LE.module("LEManager", moduleDefinition);

    return SpecialOccasionEditView;
});
